import React from 'react';
import styled from 'styled-components';
import { urlFor } from '../../../Sanityclient';
import PropTypes from 'prop-types';

const Card = styled.div`
  justify-content: center;
  margin: 1rem;
  width: 301px;
  height: 350px;
  background-color: ${'#171721'};
  cursor: pointer;
  border-radius: 12px;
  box-shadow: 0 0 12px 4px rgba(0, 0, 0, 0.4);
  overflow: hidden;
  padding: 20px 20px;
  display: flex;
  flex-direction: column;
  gap: 14px;
  transition: all 0.5s ease-in-out;
  &:hover {
    transform: translateY(-10px);
    box-shadow: 0 0 50px 4px rgba(0, 0, 0, 0.6);
  }
`;
const Image = styled.img`
  width: 100%;
  height: 90%;
  background-color: ${'#FFFFFF'};
  border-radius: 10px;
  box-shadow: 0 0 16px 2px rgba(0, 0, 0, 0.3);
`;
const Details = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 0px;
  padding: 0px 2px;
`;
const Title = styled.div`
  font-size: 20px;
  font-weight: 600;
  color: ${'#b1b2b3'};
  overflow: hidden;
  display: -webkit-box;
  max-width: 100%;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
`;
const Description = styled.div`
  font-weight: 400;
  color: ${'#b1b2b3' + 99};
  overflow: hidden;
  margin-top: 8px;
  display: -webkit-box;
  max-width: 100%;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  text-overflow: ellipsis;
`;
const AboutCard = ({ about }) => {
  return (
    <Card>
      <Image src={urlFor(about.imgUrl).url()} alt={about.title} />
      <Details>
        <Title>{about.title}</Title>
        <Description>{about.description}</Description>
      </Details>
    </Card>
  );
};

AboutCard.propTypes = {
  about: PropTypes.shape({
    imgUrl: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.shape({ url: PropTypes.string.isRequired }),
    ]).isRequired,
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
  }).isRequired,
};

export default AboutCard;
